import styled from "styled-components";
import { fill } from "../styles/utils";
import { Text } from "./Text";
import { ReactComponent as BootsLogo } from "../assets/svg/boots-logo.svg";
import { Box } from "./Box";
import { AnimatePresence, motion, Variants } from "framer-motion";
import { Portal } from "./Portal";

interface LoadingScreenProps {
  isLoading: boolean;
}

const Wrapper = styled(motion.div)`
  ${fill("fixed")}
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.blueDark};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  flex-direction: column;
`;

const wrapperVariants: Variants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const innerVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ isLoading }) => {
  return (
    <Portal>
      <AnimatePresence>
        {isLoading && (
          <Wrapper
            initial="initial"
            animate="animate"
            exit="exit"
            variants={wrapperVariants}
            transition={{ duration: 1, delay: 1 }}
          >
            <motion.div variants={innerVariants}>
              <Box>
                <BootsLogo />
              </Box>
              <Box mt={2} textAlign="center">
                <Text variant={"small"}>loading...</Text>
              </Box>
            </motion.div>
          </Wrapper>
        )}
      </AnimatePresence>
    </Portal>
  );
};
